/** KPI dashboard accent colors (aligned with incident/change reporting style). */
export const KPI_PRIMARY_BLUE = '#3465a4';
export const KPI_ORANGE = '#f5793a';
export const KPI_GREEN = '#00ba38';
export const KPI_LIGHT_BLUE = '#5b8fce';
export const KPI_TEAL = '#2dd4bf';
export const KPI_SLATE = '#64748b';

/** Bar / series rotation for multi-category charts */
export const KPI_BAR_SEQUENCE = [
  KPI_PRIMARY_BLUE,
  KPI_LIGHT_BLUE,
  KPI_ORANGE,
  KPI_GREEN,
  KPI_TEAL,
  KPI_SLATE,
] as const;

export const KPI_LINE_ACCENT = KPI_PRIMARY_BLUE;
